import { pick } from "lodash";
import { createSelector } from "@reduxjs/toolkit";

import { selectQuoteViewData } from "./quote-view";
import { selectPolicyViewData } from "./policy-view";
import { hasFeature } from "./feature-flags";

export * from "./feature-flags";

export const selectAll = (state, selectors) =>
  selectors.map(selector => selector(state));

type pickStateCreator = (
  stateKey: string | ((state: any) => any)
) => (state: any, ...keys: any[]) => any;

const pickStateCreator: pickStateCreator = stateKey =>
  createSelector(
    [
      state =>
        typeof stateKey === "function" ? stateKey(state) : state[stateKey],
      (state, ...keys) => keys || []
    ],
    (selectedState, keys) => {
      return keys.length ? pick(selectedState, keys) : selectedState;
    }
  );

export const pickAdminMode = pickStateCreator("adminMode");
export const pickEnvInfo = pickStateCreator("envInfo");
export const pickNotices = pickStateCreator("notices");
export const pickContacts = pickStateCreator("contacts");
export const pickQuoteQuickStart = pickStateCreator("quoteQuickStart");
export const pickRecentActivity = pickStateCreator("recentActivity");
export const pickQuoteGrid = pickStateCreator("quoteGrid");
export const pickPolicyGrid = pickStateCreator("policyGrid");
export const pickPolicyView = pickStateCreator("policyView");
export const pickPolicyViewData = pickStateCreator(selectPolicyViewData);
export const pickQuoteAndPolicyGrid = pickStateCreator("quoteAndPolicyGrid");
export const pickQuoteView = pickStateCreator("quoteView");
export const pickQTC = pickStateCreator("quoteTransactionComponent");
export const pickQuoteViewData = pickStateCreator(selectQuoteViewData);
export const pickTransactions = pickStateCreator("transactions");
export const pickUsers = pickStateCreator("users");
export const pickPaymentPlan = pickStateCreator("paymentPlan");
export const pickEsign = pickStateCreator("esign");
export const pickEsignPreBind = pickStateCreator("esignPreBind");
export const pickNavigation = pickStateCreator("navigation");
export const pickIPM = pickStateCreator("ipm");
export const pickFeatureFlags = pickStateCreator("featureFlags");

export const selectAuthString = state =>
  state.envInfo.agentToken != null
    ? `AgentToken ${state.envInfo.agentToken}`
    : `Basic ${state.envInfo.b64}`;

// this used to contain FedNat (fnic: "FedNat") but has since been removed.
const organizationNames = {
  cru: "SageSure"
};
export const selectOrganizationName = state =>
  organizationNames[state.envInfo.organizationID] || "";

export const selectMessages = state => state.messages;

export const hasFeatureFlag = featureFlag => state =>
  hasFeature(state, featureFlag);
